import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { ConnectionsPage } from "../features/connections/ConnectionsPage";

export const Route = createFileRoute("/connections")({
  // `event` preselects the event filter: the After the event section links
  // here with its event id.
  validateSearch: (search: Record<string, unknown>): { event?: string } =>
    typeof search.event === "string" && search.event
      ? { event: search.event }
      : {},
  component: RouteComponent,
});

function RouteComponent() {
  const { event } = Route.useSearch();
  return (
    <RequireAuth>
      {(user) => (
        <ConnectionsPage
          uid={user.uid}
          email={user.email}
          signOut={user.signOut}
          initialEventFilter={event}
        />
      )}
    </RequireAuth>
  );
}
